// extracted by mini-css-extract-plugin
export var container = "_lz-0";
export var dotAnimation = "_lz-2";
export var dotsLoading = "_lz-1";